module.exports = __webpack_public_path__ + "static/media/Project-Consumer.233d6e95.svg";